import { useContext, useEffect } from 'react';
import { GlobalSettingsContext } from '../firebase/GlobalSettingsContext';
import { UserDataContext } from '../firebase/UserDataContext';

import * as routes from '../routes/routes';
import { useLocation } from 'react-router';
import LandingPage from '../components/landing/LandingPage';
import SupportPage from '../pages/SupportPage';
import SignInPage from '../components/signin/SignIn';
import { ForgotPasswordForm } from '../components/signin/PasswordForget';
import { useNavigate } from 'react-router-dom';
import LoadingSkeleton from '../components/misc/LoadingSkeleton';


const MainRouter = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { globalSettings } = useContext(GlobalSettingsContext)
    const { user } = useContext(UserDataContext)
    useEffect(() => {
        const shouldRedirect = [routes.LANDING, routes.SIGN_IN].some((route) => location.pathname === route || location.pathname.includes(route));
        if (shouldRedirect && Object.keys(user).length > 0 && user.loggedIn) {
            navigate(routes.DASHBOARD)
        }
    }, [location.pathname, user, navigate])
    switch (true) {
        case Object.keys(globalSettings).length == 0 || Object.keys(user).length == 0:
            return <LoadingSkeleton />
        case location.pathname === routes.LANDING:
            return <LandingPage />
        case location.pathname === routes.SUPPORT:
            return <SupportPage />
        case location.pathname.includes(routes.SIGN_IN):
            return <SignInPage />
        case location.pathname.includes(routes.PASSWORD_FORGET):
            return <ForgotPasswordForm />
        default:
            return <div>Unable to route you to the correct page. Please contact a system administrator</div>

    }
}

export default MainRouter
